import { jsx as a, jsxs as Me } from "react/jsx-runtime";
import * as i from "react";
import { forwardRef as N } from "react";
import { c as v } from "../../index-DLeNytVF.js";
import { u as K, S as fo, c as be } from "../../index-nyDQUcyF.js";
import { c as _e, u as Ce } from "../../index-DY0e2-rS.js";
import { u as mo } from "../../index-BUuv-jtL.js";
import { P as T, d as wo } from "../../index--Ec6-Sd5.js";
import { c as vo } from "../../index-rZhpRpjz.js";
import { u as go } from "../../index-ByaXH_ih.js";
import { c as Re, P as ho, A as Mo, D as bo, C as _o, R as Co, a as Ro } from "../../index-Bau437MN.js";
import { h as xo, u as Do, R as Io, F as Po } from "../../Combination-DIa2QCCA.js";
import { P as z } from "../../index-BLBC6XLQ.js";
import { c as xe, I as yo, R as Eo } from "../../index-DFkG4Vuq.js";
import { u as ge } from "../../index-CYVF_faS.js";
import { c as A } from "../../cn-gv_k3DnN.js";
import { Checkbox as So } from "../checkbox/checkbox.js";
import { Icon as No } from "../icon/icon.js";
var ne = ["Enter", " "], To = ["ArrowDown", "PageUp", "Home"], De = ["ArrowUp", "PageDown", "End"], Ao = [...To, ...De], Oo = {
  ltr: [...ne, "ArrowRight"],
  rtl: [...ne, "ArrowLeft"]
}, ko = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, U = "Menu", [L, Go, Lo] = vo(U), [I, Ie] = _e(U, [
  Lo,
  Re,
  xe
]), Z = Re(), Pe = xe(), [Fo, P] = I(U), [Ko, $] = I(U), ye = (e) => {
  const { __scopeMenu: n, open: o = !1, children: t, dir: r, onOpenChange: c, modal: u = !0 } = e, l = Z(n), [m, w] = i.useState(null), p = i.useRef(!1), s = Ce(c), f = go(r);
  return i.useEffect(() => {
    const h = () => {
      p.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => p.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ a(Co, { ...l, children: /* @__PURE__ */ a(
    Fo,
    {
      scope: n,
      open: o,
      onOpenChange: s,
      content: m,
      onContentChange: w,
      children: /* @__PURE__ */ a(
        Ko,
        {
          scope: n,
          onClose: i.useCallback(() => s(!1), [s]),
          isUsingKeyboardRef: p,
          dir: f,
          modal: u,
          children: t
        }
      )
    }
  ) });
};
ye.displayName = U;
var Uo = "MenuAnchor", te = i.forwardRef(
  (e, n) => {
    const { __scopeMenu: o, ...t } = e, r = Z(o);
    return /* @__PURE__ */ a(Mo, { ...r, ...t, ref: n });
  }
);
te.displayName = Uo;
var re = "MenuPortal", [$o, Ee] = I(re, {
  forceMount: void 0
}), Se = (e) => {
  const { __scopeMenu: n, forceMount: o, children: t, container: r } = e, c = P(re, n);
  return /* @__PURE__ */ a($o, { scope: n, forceMount: o, children: /* @__PURE__ */ a(z, { present: o || c.open, children: /* @__PURE__ */ a(ho, { asChild: !0, container: r, children: t }) }) });
};
Se.displayName = re;
var _ = "MenuContent", [Bo, ae] = I(_), Ne = i.forwardRef(
  (e, n) => {
    const o = Ee(_, e.__scopeMenu), { forceMount: t = o.forceMount, ...r } = e, c = P(_, e.__scopeMenu), u = $(_, e.__scopeMenu);
    return /* @__PURE__ */ a(L.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ a(z, { present: t || c.open, children: /* @__PURE__ */ a(L.Slot, { scope: e.__scopeMenu, children: u.modal ? /* @__PURE__ */ a(Vo, { ...r, ref: n }) : /* @__PURE__ */ a(Xo, { ...r, ref: n }) }) }) });
  }
), Vo = i.forwardRef(
  (e, n) => {
    const o = P(_, e.__scopeMenu), t = i.useRef(null), r = K(n, t);
    return i.useEffect(() => {
      const c = t.current;
      if (c) return xo(c);
    }, []), /* @__PURE__ */ a(
      ce,
      {
        ...e,
        ref: r,
        trapFocus: o.open,
        disableOutsidePointerEvents: o.open,
        disableOutsideScroll: !0,
        onFocusOutside: v(
          e.onFocusOutside,
          (c) => c.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => o.onOpenChange(!1)
      }
    );
  }
), Xo = i.forwardRef((e, n) => {
  const o = P(_, e.__scopeMenu);
  return /* @__PURE__ */ a(
    ce,
    {
      ...e,
      ref: n,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => o.onOpenChange(!1)
    }
  );
}), ce = i.forwardRef(
  (e, n) => {
    const {
      __scopeMenu: o,
      loop: t = !1,
      trapFocus: r,
      onOpenAutoFocus: c,
      onCloseAutoFocus: u,
      disableOutsidePointerEvents: l,
      onEntryFocus: m,
      onEscapeKeyDown: w,
      onPointerDownOutside: p,
      onFocusOutside: s,
      onInteractOutside: f,
      onDismiss: h,
      disableOutsideScroll: g,
      ...D
    } = e, y = P(_, o), O = $(_, o), B = Z(o), V = Pe(o), le = Go(o), [co, pe] = i.useState(null), X = i.useRef(null), io = K(n, X, y.onContentChange), Y = i.useRef(0), H = i.useRef(""), so = i.useRef(0), J = i.useRef(null), fe = i.useRef("right"), Q = i.useRef(0), uo = g ? Io : i.Fragment, lo = g ? { as: fo, allowPinchZoom: !0 } : void 0, po = (d) => {
      var S, we;
      const b = H.current + d, C = le().filter((R) => !R.disabled), x = document.activeElement, ee = (S = C.find((R) => R.ref.current === x)) == null ? void 0 : S.textValue, oe = C.map((R) => R.textValue), me = nn(oe, b, ee), k = (we = C.find((R) => R.textValue === me)) == null ? void 0 : we.ref.current;
      (function R(ve) {
        H.current = ve, window.clearTimeout(Y.current), ve !== "" && (Y.current = window.setTimeout(() => R(""), 1e3));
      })(b), k && setTimeout(() => k.focus());
    };
    i.useEffect(() => () => window.clearTimeout(Y.current), []), Do();
    const E = i.useCallback((d) => {
      var C, x;
      return fe.current === ((C = J.current) == null ? void 0 : C.side) && rn(d, (x = J.current) == null ? void 0 : x.area);
    }, []);
    return /* @__PURE__ */ a(
      Bo,
      {
        scope: o,
        searchRef: H,
        onItemEnter: i.useCallback(
          (d) => {
            E(d) && d.preventDefault();
          },
          [E]
        ),
        onItemLeave: i.useCallback(
          (d) => {
            var b;
            E(d) || ((b = X.current) == null || b.focus(), pe(null));
          },
          [E]
        ),
        onTriggerLeave: i.useCallback(
          (d) => {
            E(d) && d.preventDefault();
          },
          [E]
        ),
        pointerGraceTimerRef: so,
        onPointerGraceIntentChange: i.useCallback((d) => {
          J.current = d;
        }, []),
        children: /* @__PURE__ */ a(uo, { ...lo, children: /* @__PURE__ */ a(
          Po,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: v(c, (d) => {
              var b;
              d.preventDefault(), (b = X.current) == null || b.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: u,
            children: /* @__PURE__ */ a(
              bo,
              {
                asChild: !0,
                disableOutsidePointerEvents: l,
                onEscapeKeyDown: w,
                onPointerDownOutside: p,
                onFocusOutside: s,
                onInteractOutside: f,
                onDismiss: h,
                children: /* @__PURE__ */ a(
                  Eo,
                  {
                    asChild: !0,
                    ...V,
                    dir: O.dir,
                    orientation: "vertical",
                    loop: t,
                    currentTabStopId: co,
                    onCurrentTabStopIdChange: pe,
                    onEntryFocus: v(m, (d) => {
                      O.isUsingKeyboardRef.current || d.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ a(
                      _o,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": We(y.open),
                        "data-radix-menu-content": "",
                        dir: O.dir,
                        ...B,
                        ...D,
                        ref: io,
                        style: { outline: "none", ...D.style },
                        onKeyDown: v(D.onKeyDown, (d) => {
                          const C = d.target.closest("[data-radix-menu-content]") === d.currentTarget, x = d.ctrlKey || d.altKey || d.metaKey, ee = d.key.length === 1;
                          C && (d.key === "Tab" && d.preventDefault(), !x && ee && po(d.key));
                          const oe = X.current;
                          if (d.target !== oe || !Ao.includes(d.key)) return;
                          d.preventDefault();
                          const k = le().filter((S) => !S.disabled).map((S) => S.ref.current);
                          De.includes(d.key) && k.reverse(), en(k);
                        }),
                        onBlur: v(e.onBlur, (d) => {
                          d.currentTarget.contains(d.target) || (window.clearTimeout(Y.current), H.current = "");
                        }),
                        onPointerMove: v(
                          e.onPointerMove,
                          F((d) => {
                            const b = d.target, C = Q.current !== d.clientX;
                            if (d.currentTarget.contains(b) && C) {
                              const x = d.clientX > Q.current ? "right" : "left";
                              fe.current = x, Q.current = d.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ne.displayName = _;
var Yo = "MenuGroup", ie = i.forwardRef(
  (e, n) => {
    const { __scopeMenu: o, ...t } = e;
    return /* @__PURE__ */ a(T.div, { role: "group", ...t, ref: n });
  }
);
ie.displayName = Yo;
var Ho = "MenuLabel", Te = i.forwardRef(
  (e, n) => {
    const { __scopeMenu: o, ...t } = e;
    return /* @__PURE__ */ a(T.div, { ...t, ref: n });
  }
);
Te.displayName = Ho;
var W = "MenuItem", he = "menu.itemSelect", q = i.forwardRef(
  (e, n) => {
    const { disabled: o = !1, onSelect: t, ...r } = e, c = i.useRef(null), u = $(W, e.__scopeMenu), l = ae(W, e.__scopeMenu), m = K(n, c), w = i.useRef(!1), p = () => {
      const s = c.current;
      if (!o && s) {
        const f = new CustomEvent(he, { bubbles: !0, cancelable: !0 });
        s.addEventListener(he, (h) => t == null ? void 0 : t(h), { once: !0 }), wo(s, f), f.defaultPrevented ? w.current = !1 : u.onClose();
      }
    };
    return /* @__PURE__ */ a(
      Ae,
      {
        ...r,
        ref: m,
        disabled: o,
        onClick: v(e.onClick, p),
        onPointerDown: (s) => {
          var f;
          (f = e.onPointerDown) == null || f.call(e, s), w.current = !0;
        },
        onPointerUp: v(e.onPointerUp, (s) => {
          var f;
          w.current || (f = s.currentTarget) == null || f.click();
        }),
        onKeyDown: v(e.onKeyDown, (s) => {
          const f = l.searchRef.current !== "";
          o || f && s.key === " " || ne.includes(s.key) && (s.currentTarget.click(), s.preventDefault());
        })
      }
    );
  }
);
q.displayName = W;
var Ae = i.forwardRef(
  (e, n) => {
    const { __scopeMenu: o, disabled: t = !1, textValue: r, ...c } = e, u = ae(W, o), l = Pe(o), m = i.useRef(null), w = K(n, m), [p, s] = i.useState(!1), [f, h] = i.useState("");
    return i.useEffect(() => {
      const g = m.current;
      g && h((g.textContent ?? "").trim());
    }, [c.children]), /* @__PURE__ */ a(
      L.ItemSlot,
      {
        scope: o,
        disabled: t,
        textValue: r ?? f,
        children: /* @__PURE__ */ a(yo, { asChild: !0, ...l, focusable: !t, children: /* @__PURE__ */ a(
          T.div,
          {
            role: "menuitem",
            "data-highlighted": p ? "" : void 0,
            "aria-disabled": t || void 0,
            "data-disabled": t ? "" : void 0,
            ...c,
            ref: w,
            onPointerMove: v(
              e.onPointerMove,
              F((g) => {
                t ? u.onItemLeave(g) : (u.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: v(
              e.onPointerLeave,
              F((g) => u.onItemLeave(g))
            ),
            onFocus: v(e.onFocus, () => s(!0)),
            onBlur: v(e.onBlur, () => s(!1))
          }
        ) })
      }
    );
  }
), Wo = "MenuCheckboxItem", Oe = i.forwardRef(
  (e, n) => {
    const { checked: o = !1, onCheckedChange: t, ...r } = e;
    return /* @__PURE__ */ a(Ke, { scope: e.__scopeMenu, checked: o, children: /* @__PURE__ */ a(
      q,
      {
        role: "menuitemcheckbox",
        "aria-checked": j(o) ? "mixed" : o,
        ...r,
        ref: n,
        "data-state": ue(o),
        onSelect: v(
          r.onSelect,
          () => t == null ? void 0 : t(j(o) ? !0 : !o),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Oe.displayName = Wo;
var ke = "MenuRadioGroup", [jo, zo] = I(
  ke,
  { value: void 0, onValueChange: () => {
  } }
), Ge = i.forwardRef(
  (e, n) => {
    const { value: o, onValueChange: t, ...r } = e, c = Ce(t);
    return /* @__PURE__ */ a(jo, { scope: e.__scopeMenu, value: o, onValueChange: c, children: /* @__PURE__ */ a(ie, { ...r, ref: n }) });
  }
);
Ge.displayName = ke;
var Le = "MenuRadioItem", Fe = i.forwardRef(
  (e, n) => {
    const { value: o, ...t } = e, r = zo(Le, e.__scopeMenu), c = o === r.value;
    return /* @__PURE__ */ a(Ke, { scope: e.__scopeMenu, checked: c, children: /* @__PURE__ */ a(
      q,
      {
        role: "menuitemradio",
        "aria-checked": c,
        ...t,
        ref: n,
        "data-state": ue(c),
        onSelect: v(
          t.onSelect,
          () => {
            var u;
            return (u = r.onValueChange) == null ? void 0 : u.call(r, o);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Fe.displayName = Le;
var se = "MenuItemIndicator", [Ke, Zo] = I(
  se,
  { checked: !1 }
), Ue = i.forwardRef(
  (e, n) => {
    const { __scopeMenu: o, forceMount: t, ...r } = e, c = Zo(se, o);
    return /* @__PURE__ */ a(
      z,
      {
        present: t || j(c.checked) || c.checked === !0,
        children: /* @__PURE__ */ a(
          T.span,
          {
            ...r,
            ref: n,
            "data-state": ue(c.checked)
          }
        )
      }
    );
  }
);
Ue.displayName = se;
var qo = "MenuSeparator", $e = i.forwardRef(
  (e, n) => {
    const { __scopeMenu: o, ...t } = e;
    return /* @__PURE__ */ a(
      T.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...t,
        ref: n
      }
    );
  }
);
$e.displayName = qo;
var Jo = "MenuArrow", Be = i.forwardRef(
  (e, n) => {
    const { __scopeMenu: o, ...t } = e, r = Z(o);
    return /* @__PURE__ */ a(Ro, { ...r, ...t, ref: n });
  }
);
Be.displayName = Jo;
var Qo = "MenuSub", [bt, Ve] = I(Qo), G = "MenuSubTrigger", Xe = i.forwardRef(
  (e, n) => {
    const o = P(G, e.__scopeMenu), t = $(G, e.__scopeMenu), r = Ve(G, e.__scopeMenu), c = ae(G, e.__scopeMenu), u = i.useRef(null), { pointerGraceTimerRef: l, onPointerGraceIntentChange: m } = c, w = { __scopeMenu: e.__scopeMenu }, p = i.useCallback(() => {
      u.current && window.clearTimeout(u.current), u.current = null;
    }, []);
    return i.useEffect(() => p, [p]), i.useEffect(() => {
      const s = l.current;
      return () => {
        window.clearTimeout(s), m(null);
      };
    }, [l, m]), /* @__PURE__ */ a(te, { asChild: !0, ...w, children: /* @__PURE__ */ a(
      Ae,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": o.open,
        "aria-controls": r.contentId,
        "data-state": We(o.open),
        ...e,
        ref: be(n, r.onTriggerChange),
        onClick: (s) => {
          var f;
          (f = e.onClick) == null || f.call(e, s), !(e.disabled || s.defaultPrevented) && (s.currentTarget.focus(), o.open || o.onOpenChange(!0));
        },
        onPointerMove: v(
          e.onPointerMove,
          F((s) => {
            c.onItemEnter(s), !s.defaultPrevented && !e.disabled && !o.open && !u.current && (c.onPointerGraceIntentChange(null), u.current = window.setTimeout(() => {
              o.onOpenChange(!0), p();
            }, 100));
          })
        ),
        onPointerLeave: v(
          e.onPointerLeave,
          F((s) => {
            var h, g;
            p();
            const f = (h = o.content) == null ? void 0 : h.getBoundingClientRect();
            if (f) {
              const D = (g = o.content) == null ? void 0 : g.dataset.side, y = D === "right", O = y ? -5 : 5, B = f[y ? "left" : "right"], V = f[y ? "right" : "left"];
              c.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: s.clientX + O, y: s.clientY },
                  { x: B, y: f.top },
                  { x: V, y: f.top },
                  { x: V, y: f.bottom },
                  { x: B, y: f.bottom }
                ],
                side: D
              }), window.clearTimeout(l.current), l.current = window.setTimeout(
                () => c.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (c.onTriggerLeave(s), s.defaultPrevented) return;
              c.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: v(e.onKeyDown, (s) => {
          var h;
          const f = c.searchRef.current !== "";
          e.disabled || f && s.key === " " || Oo[t.dir].includes(s.key) && (o.onOpenChange(!0), (h = o.content) == null || h.focus(), s.preventDefault());
        })
      }
    ) });
  }
);
Xe.displayName = G;
var Ye = "MenuSubContent", He = i.forwardRef(
  (e, n) => {
    const o = Ee(_, e.__scopeMenu), { forceMount: t = o.forceMount, ...r } = e, c = P(_, e.__scopeMenu), u = $(_, e.__scopeMenu), l = Ve(Ye, e.__scopeMenu), m = i.useRef(null), w = K(n, m);
    return /* @__PURE__ */ a(L.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ a(z, { present: t || c.open, children: /* @__PURE__ */ a(L.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ a(
      ce,
      {
        id: l.contentId,
        "aria-labelledby": l.triggerId,
        ...r,
        ref: w,
        align: "start",
        side: u.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (p) => {
          var s;
          u.isUsingKeyboardRef.current && ((s = m.current) == null || s.focus()), p.preventDefault();
        },
        onCloseAutoFocus: (p) => p.preventDefault(),
        onFocusOutside: v(e.onFocusOutside, (p) => {
          p.target !== l.trigger && c.onOpenChange(!1);
        }),
        onEscapeKeyDown: v(e.onEscapeKeyDown, (p) => {
          u.onClose(), p.preventDefault();
        }),
        onKeyDown: v(e.onKeyDown, (p) => {
          var h;
          const s = p.currentTarget.contains(p.target), f = ko[u.dir].includes(p.key);
          s && f && (c.onOpenChange(!1), (h = l.trigger) == null || h.focus(), p.preventDefault());
        })
      }
    ) }) }) });
  }
);
He.displayName = Ye;
function We(e) {
  return e ? "open" : "closed";
}
function j(e) {
  return e === "indeterminate";
}
function ue(e) {
  return j(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function en(e) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus(), document.activeElement !== n)) return;
}
function on(e, n) {
  return e.map((o, t) => e[(n + t) % e.length]);
}
function nn(e, n, o) {
  const r = n.length > 1 && Array.from(n).every((w) => w === n[0]) ? n[0] : n, c = o ? e.indexOf(o) : -1;
  let u = on(e, Math.max(c, 0));
  r.length === 1 && (u = u.filter((w) => w !== o));
  const m = u.find(
    (w) => w.toLowerCase().startsWith(r.toLowerCase())
  );
  return m !== o ? m : void 0;
}
function tn(e, n) {
  const { x: o, y: t } = e;
  let r = !1;
  for (let c = 0, u = n.length - 1; c < n.length; u = c++) {
    const l = n[c].x, m = n[c].y, w = n[u].x, p = n[u].y;
    m > t != p > t && o < (w - l) * (t - m) / (p - m) + l && (r = !r);
  }
  return r;
}
function rn(e, n) {
  if (!n) return !1;
  const o = { x: e.clientX, y: e.clientY };
  return tn(o, n);
}
function F(e) {
  return (n) => n.pointerType === "mouse" ? e(n) : void 0;
}
var an = ye, cn = te, sn = Se, un = Ne, dn = ie, ln = Te, pn = q, fn = Oe, mn = Ge, wn = Fe, vn = Ue, gn = $e, hn = Be, Mn = Xe, bn = He, de = "DropdownMenu", [_n, _t] = _e(
  de,
  [Ie]
), M = Ie(), [Cn, je] = _n(de), ze = (e) => {
  const {
    __scopeDropdownMenu: n,
    children: o,
    dir: t,
    open: r,
    defaultOpen: c,
    onOpenChange: u,
    modal: l = !0
  } = e, m = M(n), w = i.useRef(null), [p = !1, s] = mo({
    prop: r,
    defaultProp: c,
    onChange: u
  });
  return /* @__PURE__ */ a(
    Cn,
    {
      scope: n,
      triggerId: ge(),
      triggerRef: w,
      contentId: ge(),
      open: p,
      onOpenChange: s,
      onOpenToggle: i.useCallback(() => s((f) => !f), [s]),
      modal: l,
      children: /* @__PURE__ */ a(an, { ...m, open: p, onOpenChange: s, dir: t, modal: l, children: o })
    }
  );
};
ze.displayName = de;
var Ze = "DropdownMenuTrigger", qe = i.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: o, disabled: t = !1, ...r } = e, c = je(Ze, o), u = M(o);
    return /* @__PURE__ */ a(cn, { asChild: !0, ...u, children: /* @__PURE__ */ a(
      T.button,
      {
        type: "button",
        id: c.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": c.open,
        "aria-controls": c.open ? c.contentId : void 0,
        "data-state": c.open ? "open" : "closed",
        "data-disabled": t ? "" : void 0,
        disabled: t,
        ...r,
        ref: be(n, c.triggerRef),
        onPointerDown: v(e.onPointerDown, (l) => {
          !t && l.button === 0 && l.ctrlKey === !1 && (c.onOpenToggle(), c.open || l.preventDefault());
        }),
        onKeyDown: v(e.onKeyDown, (l) => {
          t || (["Enter", " "].includes(l.key) && c.onOpenToggle(), l.key === "ArrowDown" && c.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(l.key) && l.preventDefault());
        })
      }
    ) });
  }
);
qe.displayName = Ze;
var Rn = "DropdownMenuPortal", Je = (e) => {
  const { __scopeDropdownMenu: n, ...o } = e, t = M(n);
  return /* @__PURE__ */ a(sn, { ...t, ...o });
};
Je.displayName = Rn;
var Qe = "DropdownMenuContent", eo = i.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: o, ...t } = e, r = je(Qe, o), c = M(o), u = i.useRef(!1);
    return /* @__PURE__ */ a(
      un,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...c,
        ...t,
        ref: n,
        onCloseAutoFocus: v(e.onCloseAutoFocus, (l) => {
          var m;
          u.current || (m = r.triggerRef.current) == null || m.focus(), u.current = !1, l.preventDefault();
        }),
        onInteractOutside: v(e.onInteractOutside, (l) => {
          const m = l.detail.originalEvent, w = m.button === 0 && m.ctrlKey === !0, p = m.button === 2 || w;
          (!r.modal || p) && (u.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
eo.displayName = Qe;
var xn = "DropdownMenuGroup", oo = i.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
    return /* @__PURE__ */ a(dn, { ...r, ...t, ref: n });
  }
);
oo.displayName = xn;
var Dn = "DropdownMenuLabel", In = i.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
    return /* @__PURE__ */ a(ln, { ...r, ...t, ref: n });
  }
);
In.displayName = Dn;
var Pn = "DropdownMenuItem", no = i.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
    return /* @__PURE__ */ a(pn, { ...r, ...t, ref: n });
  }
);
no.displayName = Pn;
var yn = "DropdownMenuCheckboxItem", to = i.forwardRef((e, n) => {
  const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
  return /* @__PURE__ */ a(fn, { ...r, ...t, ref: n });
});
to.displayName = yn;
var En = "DropdownMenuRadioGroup", Sn = i.forwardRef((e, n) => {
  const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
  return /* @__PURE__ */ a(mn, { ...r, ...t, ref: n });
});
Sn.displayName = En;
var Nn = "DropdownMenuRadioItem", Tn = i.forwardRef((e, n) => {
  const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
  return /* @__PURE__ */ a(wn, { ...r, ...t, ref: n });
});
Tn.displayName = Nn;
var An = "DropdownMenuItemIndicator", On = i.forwardRef((e, n) => {
  const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
  return /* @__PURE__ */ a(vn, { ...r, ...t, ref: n });
});
On.displayName = An;
var kn = "DropdownMenuSeparator", ro = i.forwardRef((e, n) => {
  const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
  return /* @__PURE__ */ a(gn, { ...r, ...t, ref: n });
});
ro.displayName = kn;
var Gn = "DropdownMenuArrow", Ln = i.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
    return /* @__PURE__ */ a(hn, { ...r, ...t, ref: n });
  }
);
Ln.displayName = Gn;
var Fn = "DropdownMenuSubTrigger", Kn = i.forwardRef((e, n) => {
  const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
  return /* @__PURE__ */ a(Mn, { ...r, ...t, ref: n });
});
Kn.displayName = Fn;
var Un = "DropdownMenuSubContent", $n = i.forwardRef((e, n) => {
  const { __scopeDropdownMenu: o, ...t } = e, r = M(o);
  return /* @__PURE__ */ a(
    bn,
    {
      ...r,
      ...t,
      ref: n,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
$n.displayName = Un;
var Bn = ze, Vn = qe, Xn = Je, Yn = eo, Hn = oo, ao = no, Wn = to, jn = ro;
const zn = N(({ className: e, children: n, matchTriggerWidth: o, ...t }, r) => /* @__PURE__ */ a(Xn, { children: /* @__PURE__ */ a(
  Yn,
  {
    sideOffset: 8,
    ref: r,
    className: A(
      "min-w-[max(fit-content,calc(var(--fui-baseline)*3+var(--fui-subline)*3))] max-w-fit",
      "gap-sp-0_5 p-sp-2 border-(--color-dropdown-container-stroke) bg-(--color-dropdown-container-bg) flex flex-col rounded-xl border shadow-2xl",
      {
        "min-w-(--radix-dropdown-menu-trigger-width) max-w-(--radix-dropdown-menu-trigger-width)": o
      },
      e
    ),
    role: "menu",
    "aria-label": "Dropdown Menu",
    ...t,
    children: n
  }
) }));
zn.displayName = "DropdownMenuContent";
const Zn = N(({ className: e, children: n, onSelect: o, ...t }, r) => /* @__PURE__ */ a(
  ao,
  {
    ref: r,
    className: A(
      "gap-sp-2 px-sp-4 py-sp-2 text-body1 outline-hidden relative flex w-full select-none items-center rounded-sm antialiased",
      "bg-(--color-dropdown-item-bg) text-(--color-dropdown-item-content-default)",
      "data-[disabled]:pointer-events-none data-[disabled]:cursor-default data-[disabled]:bg-transparent data-[disabled]:text-(--color-dropdown-item-content-disabled)",
      "data-[highlighted]:bg-(--color-dropdown-item-bg-active) data-[highlighted]:text-(--color-dropdown-item-content-active]",
      "hover:bg-(--color-dropdown-item-bg-hover) active:bg-(--color-dropdown-item-bg-active) hover:cursor-pointer",
      e
    ),
    onSelect: o ? (c) => setTimeout(() => o == null ? void 0 : o(c), 0) : void 0,
    ...t,
    children: n
  }
));
Zn.displayName = "DropdownMenuItem";
const qn = N(({ className: e, children: n, icon: o, onSelect: t, ...r }, c) => /* @__PURE__ */ a(
  ao,
  {
    ref: c,
    className: A(
      "gap-sp-2 px-sp-4 py-sp-2 pl-sp-3 text-body1 outline-hidden relative flex w-full select-none items-center rounded-sm",
      "bg-(--color-dropdown-item-bg) text-(--color-dropdown-item-content-default)",
      "data-[disabled]:pointer-events-none data-[disabled]:cursor-default data-[disabled]:bg-transparent data-[disabled]:text-(--color-dropdown-item-content-disabled)",
      "data-[highlighted]:bg-(--color-dropdown-item-bg-active) data-[highlighted]:text-(--color-dropdown-item-content-active]",
      "hover:bg-(--color-dropdown-item-bg-hover) active:bg-(--color-dropdown-item-bg-active) hover:cursor-pointer",
      e
    ),
    role: "menuitem",
    onSelect: t ? (u) => setTimeout(() => t == null ? void 0 : t(u), 0) : void 0,
    ...r,
    children: /* @__PURE__ */ Me("div", { className: "gap-sp-3 flex items-center", children: [
      /* @__PURE__ */ a(No, { name: o, size: "md" }),
      n
    ] })
  }
));
qn.displayName = "DropdownMenuIconItem";
const Jn = N(({ className: e, children: n, ...o }, t) => /* @__PURE__ */ Me(
  Wn,
  {
    ref: t,
    role: "menuitemcheckbox",
    className: A(
      "gap-sp-2 px-sp-4 py-sp-2 text-body1 outline-hidden relative flex w-full select-none items-center rounded-sm antialiased",
      "bg-(--color-dropdown-item-bg) text-(--color-dropdown-item-content-default)",
      "data-[disabled]:pointer-events-none data-[disabled]:cursor-default data-[disabled]:bg-transparent data-[disabled]:text-(--color-dropdown-item-content-disabled)",
      "data-[highlighted]:bg-(--color-dropdown-item-bg-active) data-[highlighted]:text-(--color-dropdown-item-content-active]",
      "hover:bg-(--color-dropdown-item-bg-hover) active:bg-(--color-dropdown-item-bg-active) hover:cursor-pointer",
      e
    ),
    ...o,
    children: [
      /* @__PURE__ */ a(So, { checked: o.checked, disabled: o.disabled }),
      n
    ]
  }
));
Jn.displayName = "DropdownMenuCheckboxItem";
const Qn = N(({ className: e, children: n, ...o }, t) => /* @__PURE__ */ a(
  Hn,
  {
    ref: t,
    role: "group",
    className: A(
      "gap-sp-3 px-sp-4 py-sp-2 text-h5 outline-hidden relative flex w-full select-none items-center rounded-sm antialiased",
      "bg-(--color-dropdown-item-bg) text-(--color-dropdown-item-content-default]",
      "data-[disabled]:pointer-events-none data-[disabled]:cursor-default data-[disabled]:bg-transparent data-[disabled]:text-(--color-dropdown-item-content-disabled)",
      e
    ),
    ...o,
    children: n
  }
));
Qn.displayName = "DropdownMenuGroup";
const et = N(({ className: e, children: n, ...o }, t) => /* @__PURE__ */ a("div", { className: "h-s-2 px-sp-4 flex w-full items-center", children: /* @__PURE__ */ a(
  jn,
  {
    ref: t,
    className: A("bg-(--color-outline-primary) h-px w-full", e),
    ...o,
    children: n
  }
) }));
et.displayName = "DropdownMenuSeparator";
const ot = Bn;
ot.displayName = "DropdownMenu";
const nt = Vn;
nt.displayName = "DropdownMenuTrigger";
export {
  ot as DropdownMenu,
  Jn as DropdownMenuCheckboxItem,
  zn as DropdownMenuContent,
  Qn as DropdownMenuGroup,
  qn as DropdownMenuIconItem,
  Zn as DropdownMenuItem,
  et as DropdownMenuSeparator,
  nt as DropdownMenuTrigger
};
